import * as yup from "yup";

export const waterSupplyValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup
    .number()
    .typeError("Month is required")
    .integer()
    .min(1)
    .max(12)
    .required("Month is required"),
  year: yup
    .number()
    .typeError("Year is required")
    .integer()
    .min(1900)
    .max(3000)
    .required("Year is required"),
  source: yup.string().required("Source is required"),
  stressType: yup.string().required("Stress type is required"),
  sourceType: yup.string().required("Source type is required"),
  fuelUnit: yup.string().required("Unit is required"),
  amountOfFuel: yup
    .number()
    .typeError("Amount of water must be a valid number")
    .moreThan(0, "Amount of water must be > 0")
    .required("Amount of water is required"),
});
